<template>
    <section class="application-card">
        <div v-if="isAccredited" class="alert alert-success accredited-message mb-3">
            <div class="accredited-content">
                <div class="cert-icon-wrapper">
                    <img :src="templateDirectoryUri + '/dist/images/completion_cert.svg'" alt="Certificate" class="cert-icon" />
                </div>
                <div>
                    <strong>Congratulations! This application is currently accredited.</strong>
                    <div class="accreditation-dates">
                        {{ application.accreditation_start_date }} - {{ application.accreditation_end_date }}
                    </div>
                </div>
            </div>
        </div>

        <div class="mb-3" v-if="application.submission_date">
            <p class="text-muted mb-0">
                Submitted: {{ application.submission_date }}
            </p>
        </div>

        <div class="checklist">
            <ul>
                <li :class="{ 'completed': paymentComplete }">
                    <i v-if="paymentComplete" class="fa-solid fa-check text-success"></i>
                    <i v-else class="fa-regular fa-square unchecked"></i>
                    Submit Payment
                </li>
                <li :class="{ 'completed': standardsComplete }">
                    <i v-if="standardsComplete" class="fa-solid fa-check text-success"></i>
                    <i v-else class="fa-regular fa-square unchecked"></i>
                    <a v-if="paymentComplete" :href="standardsLink" class="standards-link">
                        Complete Standards ({{ standardsCompleted }}/{{ standardsTotal }})
                    </a>
                    <span v-else class="standards-text">
                        Complete Standards ({{ standardsCompleted }}/{{ standardsTotal }})
                    </span>
                </li>
                <li :class="{ 'completed': applicationSubmitted }">
                    <i v-if="applicationSubmitted" class="fa-solid fa-check text-success"></i>
                    <i v-else class="fa-regular fa-square unchecked"></i>
                    Submit Application
                </li>
            </ul>

            <div v-if="!applicationSubmitted" class="alert alert-warning mt-3 ml-1 mr-1">
                <i class="fa-solid fa-exclamation-triangle"></i>
                <strong>Please ensure that all facilities, machines, and staff are added and documented before submission.</strong>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            application: {
                type: Object,
                required: true
            },
            paymentComplete: {
                type: Boolean,
                default: false
            },
            standardsCompleted: {
                type: Number,
                default: 0
            },
            standardsTotal: {
                type: Number,
                default: 0
            },
            standardsLink: {
                type: String,
                default: '#'
            },
            isAccredited: {
                type: Boolean,
                default: false
            },
            templateDirectoryUri: {
                type: String,
                required: true
            }
        },
        computed: {
            standardsComplete() {
                return this.standardsCompleted === this.standardsTotal && this.standardsTotal > 0;
            },
            standardsProgress() {
                if (this.standardsTotal === 0) return 0;
                return Math.round((this.standardsCompleted / this.standardsTotal) * 100);
            },
            applicationSubmitted() {
                return this.application.submission_date ? true : false;
            }
        }
    }
</script>
